/* np-bundle-page.js — behaviour for sections/new-bundle.liquid.
   Cart add + the tier discount both go through the shared window.npCart API
   (assets/np-chrome.js): the BUNDLE12/16/20 code is applied via opts.discount,
   awaited before the slide cart opens. No hidden iframe. */
(function () {
  "use strict";
  var $ = function (id) { return document.getElementById(id); };
  var money = function (n) { return "£" + n.toFixed(2); };

  /* Lipscore is the store's review platform; hydrate rating widgets.
     The theme's app embed usually loads it — this is a fallback. */
  if (!document.querySelector('script[src*="lipscore"]')) {
    window.lipscoreInit = function () { window.lipscore.init({ apiKey: "54b15725d0301f12251693f6" }); };
    var lsc = document.createElement("script");
    lsc.async = true;
    lsc.src = "https://static.lipscore.com/assets/en/lipscore-v1.js";
    document.head.appendChild(lsc);
  }

  var CATS = ["All products", "Creatine", "Hydration", "Protein", "Pre-Workout", "Daily Health"];
  /* real Build-a-Bundle ladder + checkout codes (read from the live app) */
  function tierFor(n) {
    if (n >= 5) return { pct: 0.20, code: "BUNDLE20", id: "pro" };
    if (n === 4) return { pct: 0.16, code: "BUNDLE16", id: "athlete" };
    if (n === 3) return { pct: 0.12, code: "BUNDLE12", id: "starter" };
    return { pct: 0, code: null, id: null };
  }

  var cards = [].slice.call(document.querySelectorAll("[data-bitem]"));
  var qty = {};
  cards.forEach(function (c, i) {
    c.dataset.bidx = i;
    qty[i] = 0;
    var sel = c.querySelector("[data-bflavour]");
    if (sel) {
      c.dataset.flavour = sel.options[sel.selectedIndex].text;
      sel.addEventListener("change", function () { applyFlavour(c, sel); render(); });
    }
  });
  function applyFlavour(c, sel) {
    var opt = sel.options[sel.selectedIndex];
    c.dataset.vid = sel.value;
    c.dataset.flavour = opt.text;
    c.dataset.img = opt.getAttribute("data-vthumb");
    var main = c.querySelector("a img");
    if (main && opt.getAttribute("data-vimg")) main.src = opt.getAttribute("data-vimg");
  }
  var cat = "All products";

  var PRESETS = [
    { name: "The Hybrid Stack", tag: "Most popular",
      why: "For training that mixes lifting and running. Covers protein, creatine and electrolytes in four products.",
      handles: ["efectiv-whey-protein-powder-60-servings", "efectiv-hybrid-creatine-hydration-300g", "efectiv-hydration-electrolytes-330g", "efectiv-peptide-muscle-builder-120-capsules"] },
    { name: "The Strength Stack", tag: "Build muscle",
      why: "Whey protein and creatine, plus MPS185.",
      handles: ["efectiv-whey-protein-powder-60-servings", "creatine-monohydrate-300g", "efectiv-mps185-120-capsules-muscle-builder"] },
    { name: "The Endurance Stack", tag: "HYROX & running",
      why: "Fuel for the session, hydration for what you sweat out and protein afterwards.",
      handles: ["efectiv-carbs", "efectiv-hydration-electrolytes-330g", "efectiv-whey-protein-powder-60-servings", "the-sauce-crossfit-pre-workout-20-servings-daily-driver"] }
  ];
  var byHandle = {};
  cards.forEach(function (c) {
    var href = c.querySelector("a").getAttribute("href");
    PRESETS.forEach(function (p) { p.handles.forEach(function (h) { if (href.indexOf(h) > -1) byHandle[h] = c; }); });
  });

  /* picks handed over by the home page's "Full bundle builder" link: ?picks=handle:variant,...
     each one goes in at quantity 1 with its flavour already chosen */
  (function () {
    var raw = null;
    try { raw = new URLSearchParams(window.location.search).get("picks"); } catch (e) {}
    if (!raw) return;
    raw.split(",").forEach(function (pair) {
      var bits = pair.split(":"), handle = "/products/" + bits[0], vid = bits[1];
      cards.forEach(function (c) {
        var path = c.querySelector("a").getAttribute("href").split("?")[0];
        if (path.slice(-handle.length) !== handle) return;
        qty[c.dataset.bidx] = Math.min(9, qty[c.dataset.bidx] + 1);
        var sel = c.querySelector("[data-bflavour]");
        if (sel && vid && /^\d+$/.test(vid) && sel.querySelector('option[value="' + vid + '"]')) {
          sel.value = vid;
          applyFlavour(c, sel);
        }
      });
    });
  })();

  /* Shopify floors a percentage code per unit (then x quantity), so the panel
     does the same to show exactly what checkout will charge (pence in/out). */
  function lineOff(pence, pct) { return Math.floor(pence * pct + 1e-9); }
  function count() { var n = 0; for (var k in qty) n += qty[k]; return n; }
  function gross() {
    var g = 0;
    cards.forEach(function (c) { g += qty[c.dataset.bidx] * parseInt(c.dataset.price, 10); });
    return g / 100;
  }

  /* funnel events (np-chrome.js npTrack): started once, each tier once per page view, even when a ready-made
     stack jumps straight to 5 */
  var tracked = {};
  function track(name, data) { if (window.npTrack) window.npTrack(name, data); }
  function trackSteps(n) {
    if (n > 0 && !tracked.start) { tracked.start = 1; track("bundle_started", { source: "builder_page" }); }
    [3, 4, 5].forEach(function (k) {
      var tk = tierFor(k);
      if (n >= k && !tracked[tk.id]) { tracked[tk.id] = 1; track("bundle_tier_" + Math.round(tk.pct * 100), { source: "builder_page", items: n }); }
    });
  }

  function render() {
    var n = count(), g = gross(), t = tierFor(n);
    trackSteps(n);
    cards.forEach(function (c) {
      var q = qty[c.dataset.bidx];
      c.querySelector("[data-bqty]").textContent = q;
      c.querySelector("[data-bring]").style.opacity = q > 0 ? 1 : 0;
      var showPct = t.pct > 0 ? t.pct : 0.20;
      c.querySelector("[data-boff]").childNodes[0].textContent = Math.round(showPct * 100) + "%";
      var p = parseInt(c.dataset.price, 10);
      c.querySelector("[data-bprice]").textContent = money((p - lineOff(p, showPct)) / 100);
      var vis = cat === "All products" || c.dataset.cat === cat;
      c.style.display = vis ? "flex" : "none";
    });
    updateFilters();

    $("nb-countlabel").textContent = n + " product" + (n === 1 ? "" : "s");
    $("nb-clear").style.opacity = n ? 1 : 0.62;
    $("nb-filled").style.display = n ? "block" : "none";
    $("nb-emptyrail").style.display = n ? "none" : "block";

    var lines = $("nb-lines");
    lines.innerHTML = "";
    cards.forEach(function (c) {
      var q = qty[c.dataset.bidx];
      if (!q) return;
      var each = parseInt(c.dataset.price, 10) / 100;

      var row = document.createElement("div");
      row.style.cssText = "display:flex;align-items:center;gap:12px";

      var thumb = document.createElement("span");
      thumb.style.cssText = "position:relative;width:44px;height:44px;border-radius:9px;overflow:hidden;background:rgba(255,255,255,.08);flex:none;display:block";
      var thumbImg = document.createElement("img");
      thumbImg.src = c.dataset.img;
      thumbImg.width = 44; thumbImg.height = 44;
      thumbImg.style.cssText = "position:absolute;inset:0;width:100%;height:100%;object-fit:cover";
      thumb.appendChild(thumbImg);

      var info = document.createElement("span");
      info.style.cssText = "flex:1;min-width:0;display:block";
      var nameLine = document.createElement("span");
      nameLine.style.cssText = "display:block;font:600 13.5px/1.3 Inter,system-ui,sans-serif;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:#fff";
      nameLine.textContent = c.dataset.name + (c.dataset.flavour ? " · " + c.dataset.flavour : "");
      var subLine = document.createElement("span");
      subLine.style.cssText = "display:block;font:400 11.5px/1.3 Inter,system-ui,sans-serif;color:rgba(255,255,255,.62);margin-top:4px";
      subLine.textContent = "×" + q + " · " + money(each) + " each";
      info.appendChild(nameLine);
      info.appendChild(subLine);

      var priceEl = document.createElement("span");
      priceEl.style.cssText = "font:600 13.5px/1 'Kode Mono',ui-monospace,monospace;flex:none;white-space:nowrap;color:#fff";
      priceEl.textContent = money(each * q);

      var removeBtn = document.createElement("button");
      removeBtn.type = "button";
      removeBtn.style.cssText = "width:24px;height:24px;border-radius:50%;border:1px solid rgba(255,255,255,.24);background:none;color:rgba(255,255,255,.6);font:500 13px/1 Inter,system-ui,sans-serif;cursor:pointer;flex:none";
      removeBtn.textContent = "×";
      removeBtn.setAttribute("aria-label", "Remove " + c.dataset.name);
      removeBtn.addEventListener("click", function () { qty[c.dataset.bidx] = 0; render(); });

      row.appendChild(thumb);
      row.appendChild(info);
      row.appendChild(priceEl);
      row.appendChild(removeBtn);
      lines.appendChild(row);
    });

    var discP = 0;
    if (t.pct) cards.forEach(function (c) { discP += qty[c.dataset.bidx] * lineOff(parseInt(c.dataset.price, 10), t.pct); });
    var disc = discP / 100;
    var net = g - disc;
    var ship = net >= 30 || n === 0 ? 0 : 1.99;
    $("nb-gross").textContent = money(g);
    $("nb-disclabel").textContent = t.pct ? "Bundle discount (" + Math.round(t.pct * 100) + "%)" : "Bundle discount";
    $("nb-discamt").textContent = t.pct ? "−" + money(disc) : "–";
    $("nb-ship").textContent = ship ? money(ship) : "FREE";
    $("nb-strike").textContent = money(g);
    $("nb-strike").style.opacity = t.pct ? 1 : 0;
    $("nb-total").textContent = money(net);
    /* Once a tier is reached, say so first; the next tier is an optional extra (Adam 19 Oct 2026: "add 1 more"
       on its own read as if no discount applied yet). */
    $("nb-savingline").textContent = t.pct
      ? "You save " + money(disc) + " (" + Math.round(t.pct * 100) + "%)" + (n < 5 ? " · 1 more for " + Math.round(tierFor(n + 1).pct * 100) + "%" : " · top tier")
      : "Add " + (3 - n) + " more to unlock 12%";
    $("nb-shipnote").textContent = net >= 30 ? "Free UK delivery" : "Free delivery over £30";

    var cta = $("nb-cta");
    cta.textContent = n ? "Add bundle to cart · " + money(net) : "Pick your first product";

    /* sticky tier bar (always on, design behaviour) */
    $("nb-boxline").textContent = n === 0
      ? "Add any three products to unlock 12% off"
      : n < 3 ? "Add " + (3 - n) + " more for 12% off"
      : n === 3 ? "12% off unlocked · 1 more for 16%"
      : n === 4 ? "16% off unlocked · 1 more for 20%"
      : "Box filled: maximum 20% off unlocked";
    $("nb-tierw").style.width = Math.min(100, (n / 5) * 100) + "%";
    $("nb-boxcount").textContent = n + " / 5";
    $("nb-boxcta").textContent = n ? "Add to cart" : "Start";
  }

  /* filter chips are built once, then only their active state changes on
     each render() — rebuilding them on every click destroyed the button the
     user just focused and moving keyboard focus to <body>. */
  var filterButtons = [];
  function buildFilters() {
    var fw = $("nb-filters");
    if (!fw) return;
    CATS.forEach(function (name) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "nb-filter";
      var label = document.createElement("span");
      label.textContent = name + " ";
      var countEl = document.createElement("span");
      countEl.style.opacity = ".62";
      label.appendChild(countEl);
      b.appendChild(label);
      b.setAttribute("aria-pressed", "false");
      b.addEventListener("click", function () { cat = name; render(); });
      fw.appendChild(b);
      filterButtons.push({ name: name, btn: b, countEl: countEl });
    });
  }
  function updateFilters() {
    filterButtons.forEach(function (entry) {
      var on = cat === entry.name;
      var cnt = entry.name === "All products" ? cards.length : cards.filter(function (c) { return c.dataset.cat === entry.name; }).length;
      entry.btn.style.cssText = "border:1px solid " + (on ? "#0B0B0B" : "rgba(11,11,11,.16)") + ";background:" + (on ? "#0B0B0B" : "#fff") + ";color:" + (on ? "#FFDD0E" : "#0B0B0B") + ";border-radius:100px;padding:12px 20px;font:600 13px/1 Inter,system-ui,sans-serif;cursor:pointer;white-space:nowrap";
      entry.btn.setAttribute("aria-pressed", on ? "true" : "false");
      entry.countEl.textContent = cnt;
    });
  }

  cards.forEach(function (c) {
    c.querySelector("[data-badd]").addEventListener("click", function () { qty[c.dataset.bidx] = Math.min(9, qty[c.dataset.bidx] + 1); render(); });
    c.querySelector("[data-bdec]").addEventListener("click", function () { qty[c.dataset.bidx] = Math.max(0, qty[c.dataset.bidx] - 1); render(); });
  });
  if ($("nb-clear")) $("nb-clear").addEventListener("click", function () { for (var k in qty) qty[k] = 0; render(); });

  /* presets */
  var pw = $("nb-presets");
  if (pw) {
    PRESETS.forEach(function (p) {
      var sum = 0, items = [], prices = [];
      p.handles.forEach(function (h) {
        var c = byHandle[h];
        if (!c) return;
        sum += parseInt(c.dataset.price, 10) / 100;
        prices.push(parseInt(c.dataset.price, 10));
        items.push(c.dataset.name);
      });
      var t = tierFor(items.length);
      var off = prices.reduce(function (a, pence) { return a + lineOff(pence, t.pct); }, 0) / 100;

      var card = document.createElement("div");
      card.style.cssText = "background:#fff;border:1px solid rgba(11,11,11,.1);border-radius:20px;padding:28px 26px 26px;display:flex;flex-direction:column";

      var head = document.createElement("div");
      head.style.cssText = "display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:16px";
      var tagEl = document.createElement("span");
      tagEl.style.cssText = "font:500 9.5px/1 'Kode Mono',ui-monospace,monospace;letter-spacing:.14em;text-transform:uppercase;color:rgba(11,11,11,.62)";
      tagEl.textContent = p.tag;
      var saveEl = document.createElement("span");
      saveEl.style.cssText = "background:#FFDD0E;padding:5px 10px;border-radius:100px;font:700 9px/1 'Kode Mono',ui-monospace,monospace;letter-spacing:.1em;white-space:nowrap";
      saveEl.textContent = "SAVE " + Math.round(t.pct * 100) + "%";
      head.appendChild(tagEl); head.appendChild(saveEl);

      var nameEl = document.createElement("div");
      nameEl.style.cssText = "font:700 23px/1.15 'Xenon Nue','Helvetica Neue',Helvetica,Arial,sans-serif;letter-spacing:.005em;margin-bottom:12px";
      nameEl.textContent = p.name;

      var whyEl = document.createElement("p");
      whyEl.style.cssText = "font:400 14.5px/1.55 Inter,system-ui,sans-serif;color:rgba(11,11,11,.58);margin:0 0 20px;text-wrap:pretty";
      whyEl.textContent = p.why;

      var listEl = document.createElement("div");
      listEl.style.cssText = "display:flex;flex-direction:column;gap:9px;margin-bottom:22px";
      items.forEach(function (i) {
        var row = document.createElement("div");
        row.style.cssText = "display:flex;gap:10px;font:400 14px/1.35 Inter,system-ui,sans-serif;color:rgba(11,11,11,.72)";
        var tick = document.createElement("span");
        tick.style.cssText = "color:#0B0B0B;background:#FFDD0E;width:17px;height:17px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;flex:none;margin-top:1px";
        tick.textContent = "✓";
        var text = document.createElement("span");
        text.textContent = i;
        row.appendChild(tick); row.appendChild(text);
        listEl.appendChild(row);
      });

      var footer = document.createElement("div");
      footer.style.cssText = "margin-top:auto;border-top:1px solid rgba(11,11,11,.1);padding-top:18px;display:flex;align-items:center;justify-content:space-between;gap:12px";
      var priceWrap = document.createElement("span");
      var priceRow = document.createElement("span");
      priceRow.style.cssText = "display:flex;align-items:baseline;gap:9px";
      var nowPrice = document.createElement("span");
      nowPrice.style.cssText = "font:800 22px/1 'Xenon Nue','Helvetica Neue',Helvetica,Arial,sans-serif;letter-spacing:.015em";
      nowPrice.textContent = money(sum - off);
      var wasPrice = document.createElement("span");
      wasPrice.style.cssText = "font:400 14px/1 Inter,system-ui,sans-serif;color:rgba(11,11,11,.62);text-decoration:line-through";
      wasPrice.textContent = money(sum);
      priceRow.appendChild(nowPrice); priceRow.appendChild(wasPrice);
      var saveLine = document.createElement("span");
      saveLine.style.cssText = "display:block;font:500 9.5px/1.3 'Kode Mono',ui-monospace,monospace;letter-spacing:.08em;color:rgba(11,11,11,.62);margin-top:7px;white-space:nowrap";
      saveLine.textContent = "You save " + money(off);
      priceWrap.appendChild(priceRow); priceWrap.appendChild(saveLine);

      var loadBtn = document.createElement("button");
      loadBtn.type = "button";
      loadBtn.style.cssText = "height:42px;padding:0 20px;border:0;border-radius:12px;background:#FFDD0E;color:#0B0B0B;font:700 12.5px/1 Inter,system-ui,sans-serif;cursor:pointer;flex:none;white-space:nowrap";
      loadBtn.textContent = "Load stack";
      loadBtn.addEventListener("click", function () {
        for (var k in qty) qty[k] = 0;
        p.handles.forEach(function (h) { var c = byHandle[h]; if (c) qty[c.dataset.bidx] = 1; });
        render();
        var el = document.getElementById("builder");
        if (el) window.scrollTo({ top: el.offsetTop - 80, behavior: "smooth" });
      });

      footer.appendChild(priceWrap);
      footer.appendChild(loadBtn);

      card.appendChild(head);
      card.appendChild(nameEl);
      card.appendChild(whyEl);
      card.appendChild(listEl);
      card.appendChild(footer);
      pw.appendChild(card);
    });
    /* the stacks row now has content: let the shared swipe hint measure it */
    if (window.npSwipe) window.npSwipe();
  }

  /* checkout: live app mechanism — properties + BUNDLE code via the shared cart API */
  function addBundle() {
    var n = count(), t = tierFor(n);
    if (n === 0) {
      var el = document.getElementById("builder");
      if (el) window.scrollTo({ top: el.offsetTop - 80, behavior: "smooth" });
      return;
    }
    var bundleId = (t.id || "none") + "-" + Date.now();
    var items = [];
    cards.forEach(function (c) {
      if (qty[c.dataset.bidx] > 0) {
        var line = { id: parseInt(c.dataset.vid, 10), quantity: qty[c.dataset.bidx] };
        if (t.id) line.properties = { _bundle_id: bundleId, _bundle_tier: t.id };
        items.push(line);
      }
    });
    var cta = $("nb-cta");
    if (!window.npCart) return;
    var discP = 0;
    if (t.pct) cards.forEach(function (c) { discP += qty[c.dataset.bidx] * lineOff(parseInt(c.dataset.price, 10), t.pct); });
    var value = Math.round((gross() - discP / 100) * 100) / 100;
    /* npCart announces failures in its toast */
    window.npCart.add(items, { button: cta, discount: t.code || undefined }).then(function () {
      track("bundle_added_to_cart", { source: "builder_page", tier: Math.round(t.pct * 100), items: n, value: value, currency: "GBP" });
      for (var k in qty) qty[k] = 0;
      render();
    }).catch(render);
  }
  if ($("nb-cta")) $("nb-cta").addEventListener("click", addBundle);
  if ($("nb-boxcta")) $("nb-boxcta").addEventListener("click", addBundle);

  /* faq accordions (shared .npfaq-* classes, see np-base.css) */
  var faqButtons = document.querySelectorAll("[data-acc]");
  faqButtons.forEach(function (btn) {
    btn.setAttribute("aria-expanded", "false");
    btn.addEventListener("click", function () {
      var open = btn.getAttribute("aria-expanded") === "true";
      faqButtons.forEach(function (b) {
        b.setAttribute("aria-expanded", "false");
        var bd = b.parentElement.querySelector(".npfaq-body");
        if (bd) bd.classList.remove("is-open");
      });
      if (!open) {
        btn.setAttribute("aria-expanded", "true");
        var body = btn.parentElement.querySelector(".npfaq-body");
        if (body) body.classList.add("is-open");
      }
    });
  });

  buildFilters();
  render();
})();
